import * as config from './../config/config'
import api from './interceptor'


export async function get_liste_maintenance(entretien_id){
  try {
    const response = await api.get(config.REACT_APP_ENDPOINT_LIST_MAINTENANCE_ENTRETIEN + '/' + entretien_id);
    return response.data;
  } catch (error) {
    throw error;
  }
};

export async function create_maintenance(data, info){
  try {
    const response = await api.post(config.REACT_APP_ENDPOINT_CREATE_MAINTENANCE, {
        "nom": data['nom'],
        "quantite": data["quantite"],
        "prix": data['prix'],
        "description": data['description'],
        "entretien_id":  info['entretien_id']
    });
    return response.data;
  } catch (error) {
    throw error;
  }
};